import { useSelector } from 'react-redux';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import './ag-theme-base.css';
import '@ag-grid-enterprise/row-grouping';
import { ModuleRegistry, provideGlobalGridOptions } from 'ag-grid-community';
import { AllEnterpriseModule, LicenseManager } from 'ag-grid-enterprise';
import './style.css';

LicenseManager.setLicenseKey(import.meta.env.VITE_AG_GRID_LICENSE_KEY);
ModuleRegistry.registerModules([AllEnterpriseModule]);
provideGlobalGridOptions({ theme: 'legacy' });

// AGGridBase is to be used instead of redefining AgGridReact as we only want to define it once due to the set up with the license
const AGGridBase = ({
    gridRef,
    tableData,
    masterDetail,
    isLoading,
    quickFilterText,
    customCellRenderer,
    pathname,
    defaultColDef,
    autoGroupColumnDef,
    autoSizeStrategy,
    isRowMaster,
    rowModelType,
    onStateUpdated,
    onColumnMoved,
    defaultCsvExportParams,
    rowSelection,
    onRowClicked,
    onSelectionChanged,
    overlayNoRowsTemplate,
    ...props
}) => {
    const { darkMode } = useSelector((state) => {
        return { ...state.settings };
    });

    return (
        <div
            className={
                darkMode
                    ? 'ag-theme-material-dark ag-theme-base'
                    : 'ag-theme-material ag-theme-base ag-theme-base-light'
            }
            style={{
                height:
                    window.innerHeight -
                    window.innerHeight / (pathname.includes('numbers') ? 3 : 4),
                width: '100%',
            }}>
            <AgGridReact
                loadThemeGoogleFonts
                ref={gridRef}
                columnDefs={tableData.columns}
                rowData={tableData.data}
                loading={isLoading}
                suppressServerSideFullWidthLoadingRow={true}
                autoGroupColumnDef={autoGroupColumnDef}
                pagination={true}
                paginationPageSize={50}
                animateRows={true}
                masterDetail={masterDetail}
                isRowMaster={isRowMaster}
                quickFilterText={quickFilterText}
                groupDisplayType="groupRows"
                rowGroupPanelShow="onlyWhenGrouping"
                detailRowAutoHeight={true}
                rowModelType={rowModelType}
                rowSelection={rowSelection}
                onSelectionChanged={onSelectionChanged}
                onRowClicked={onRowClicked}
                defaultColDef={{
                    ...defaultColDef,
                    cellRenderer: customCellRenderer,
                }}
                defaultCsvExportParams={defaultCsvExportParams}
                defaultExcelExportParams={defaultCsvExportParams}
                detailCellRendererParams={tableData.detailCellRendererParams}
                autoSizeStrategy={autoSizeStrategy}
                onStateUpdated={onStateUpdated}
                onColumnMoved={onColumnMoved}
                overlayNoRowsTemplate={overlayNoRowsTemplate}
                {...props}
            />
        </div>
    );
};

export default AGGridBase;
